import {
  generateUniqKey,
  CALCMODE1_CONFIG,
  PAY_ARG_DEFINE,
  intToChinese,
  PAY_PLAN_DEFINE,
  CALCMODE2_CONFIG,
  CALCMODE3_CONFIG,
  STAGE_PAY_PLAN_DEFINE,
} from './constants';

const filterInvalidData = (arr) => arr.filter((item) => item.status !== 0);

const initialState = {
  salaryScheme: {},
  planData: [],
  paramsData: {},
  stationConfig: {},
  operateMode: '',
  aggregateDimConf: {},
  modeNoMap: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    // 重置所有数据
    case 'RESET_ALL_DATA': {
      return {
        ...state,
        salaryScheme: {},
        planData: [],
        paramsData: {},
        stationConfig: {},
        aggregateDimConf: {},
        modeNoMap: {},
      };
    }
    // 设置当前操作模式
    case 'SET_OPERATE_MODE': {
      return {
        ...state,
        operateMode: action.payload,
      };
    }
    // 获取计薪方案详情
    case 'SET_SALARYSCHEME_DATA': {
      const modeNoMap = {};
      const planData =
        action.payload.planData?.map((mode, modeIndex) => {
          modeNoMap[modeIndex] = [modeIndex + 1, intToChinese(modeIndex + 1)];
          const plans = mode.plans.map((condition, conditionIndex) => {
            if (mode.compute_mode === 3) {
              let paidPaidTemp;
              let paid_params;
              let paid_plan_param;
              const tempPaid = condition.paid_params;
              if (Array.isArray(tempPaid.paid_params_aggr)) {
                paid_params = tempPaid.paid_params_aggr.map((list, listIndex) => ({
                  ...list,
                  key: generateUniqKey('paid_param', listIndex),
                }));
              }
              if (Array.isArray(tempPaid.paid_plan_param)) {
                paid_plan_param = tempPaid.paid_plan_param.map((list, listIndex) => ({
                  ...list,
                  key: generateUniqKey('paid_plan_param', listIndex),
                }));
              } else {
                paid_plan_param = [
                  {
                    ...PAY_ARG_DEFINE,
                    key: generateUniqKey('paid_plan_param', 0),
                  },
                ];
              }
              paidPaidTemp = {
                paid_params,
                paid_plan_param,
                ladder_unit: tempPaid.ladder_unit,
              };
              return {
                ...condition,
                ...paidPaidTemp,
                key: generateUniqKey('plans', conditionIndex),
              };
            } else {
              let paid_params;
              if (Array.isArray(condition.paid_params)) {
                paid_params = condition.paid_params.map((paid_param, paramIndex) => ({
                  ...paid_param,
                  key: generateUniqKey('paid_param', paramIndex),
                }));
              } else {
                paid_params = condition.paid_params;
              }
              return {
                ...condition,
                paid_params,
                key: generateUniqKey('plans', conditionIndex),
              };
            }
          });
          const item = {
            ...mode,
            compute_mode: String(mode.compute_mode),
            aggregate_dim: String(mode.aggregate_dim),
            plans,
            key: generateUniqKey('planData', modeIndex),
          };
          return item;
        }) || [];
      const salaryScheme = {
        ...state.salaryScheme,
        ...action.payload,
        taskType: action.payload.taskType
          ? String(action.payload.taskType)
          : action.payload.taskType,
        computeMode: action.payload.computeMode
          ? String(action.payload.computeMode)
          : action.payload.computeMode,
        computeLogic: action.payload.computeLogic
          ? String(action.payload.computeLogic)
          : action.payload.computeLogic,
        planData,
      };
      return {
        ...state,
        salaryScheme,
        planData,
        modeNoMap,
      };
    }

    case 'SET_PLAN_DATA': {
      let planData;
      let modeNoMap;
      switch (action.payload) {
        case '1':
          {
            const data = [
              {
                ...CALCMODE1_CONFIG,
                key: generateUniqKey('planData', 0),
                plans: [
                  {
                    ...PAY_PLAN_DEFINE,
                    key: generateUniqKey('plans', 0),
                    paid_params: [
                      {
                        ...PAY_ARG_DEFINE,
                        key: generateUniqKey('paid_param', 0),
                      },
                    ],
                  },
                ],
              },
            ];
            planData = data;
          }
          break;
        case '2':
          {
            const data = [
              {
                ...CALCMODE2_CONFIG,
                key: generateUniqKey('planData', 0),
                plans: [
                  {
                    ...PAY_PLAN_DEFINE,
                    key: generateUniqKey('plans', 0),
                    sub_compute_mode: 2,
                    paid_params: [
                      {
                        ...PAY_ARG_DEFINE,
                        key: generateUniqKey('paid_param', 0),
                      },
                    ],
                  },
                ],
              },
            ];
            planData = data;
          }
          break;
        case '3':
          {
            const data = [
              {
                ...CALCMODE3_CONFIG,
                key: generateUniqKey('planData', 0),
                plans: [
                  {
                    paid_plan_param: [
                      {
                        ...PAY_ARG_DEFINE,
                        key: generateUniqKey('paid_plan_param', 0),
                      },
                    ],
                    paid_params: STAGE_PAY_PLAN_DEFINE.map((item, index) => ({
                      ...item,
                      key: generateUniqKey('paid_params', index),
                    })),
                    key: generateUniqKey('plans', 0),
                  },
                ],
              },
            ];
            planData = data;
          }
          break;
        case '4':
          {
            const data = [
              {
                ...CALCMODE1_CONFIG,
                key: generateUniqKey('planData', 0),
                plans: [
                  {
                    ...PAY_PLAN_DEFINE,
                    key: generateUniqKey('plans', 0),
                    paid_params: [
                      {
                        ...PAY_ARG_DEFINE,
                        key: generateUniqKey('paid_param', 0),
                      },
                    ],
                  },
                ],
              },
              {
                ...CALCMODE2_CONFIG,
                key: generateUniqKey('planData', 1),
                plans: [
                  {
                    ...PAY_PLAN_DEFINE,
                    key: generateUniqKey('plans', 0),
                    sub_compute_mode: 2,
                    paid_params: [
                      {
                        ...PAY_ARG_DEFINE,
                        key: generateUniqKey('paid_param', 0),
                      },
                    ],
                  },
                ],
              },
            ];
            planData = data;
            modeNoMap = {
              0: [1, '一'],
              1: [2, '二'],
            };
          }
          break;
        default:
          break;
      }
      return {
        ...state,
        planData,
        modeNoMap,
      };
    }
    // 聚合维度配置
    case 'SET_AGGREGATE_DIM_CONF': {
      return {
        ...state,
        aggregateDimConf: action.payload,
      };
    }
    // 设置计薪参数数据
    case 'SET_PARAMS_DATA': {
      const paramsType1 = [];
      const paramsType2 = [];
      const paramsType3 = [];
      let newParamsList = [];
      if (action.payload.paramsList) {
        newParamsList = action.payload.paramsList
          .filter((item) => item.dim)
          .map((item) => {
            // 承运商的特殊处理（如果value没值，则改为文本输入）
            if (item.englishField === 'carrier' && !item.value?.length) {
              return { ...item, type: 3 };
            }
            return item;
          });
        newParamsList.forEach((params) => {
          if (params.dim.includes(1) || params.dim.includes('1')) {
            paramsType1.push(params);
          }
          if (params.dim.includes(2) || params.dim.includes('2')) {
            paramsType2.push(params);
          }
          if (params.dim.includes(3) || params.dim.includes('3')) {
            paramsType3.push(params);
          }
        });
      }
      return {
        ...state,
        paramsData: {
          ...action.payload,
          paramsList: newParamsList,
          paramsType1,
          paramsType2,
          paramsType3,
        },
      };
    }
    // 设置站点信息
    case 'SET_STATION_CONFIG': {
      const taskMap = {};
      const originTaskMap = action.payload.taskMap;
      Object.keys(originTaskMap).forEach((taskType) => {
        taskMap[taskType] = filterInvalidData(originTaskMap[taskType]);
      });
      return {
        ...state,
        stationConfig: {
          ...action.payload,
          customerGroupMap: filterInvalidData(action.payload.customerGroupMap),
          taskMap,
        },
      };
    }
    case 'UPDATE_SALARYSCHEME_BASEINFO': {
      const salaryScheme = {
        ...state.salaryScheme,
        ...action.payload,
      };
      return {
        ...state,
        salaryScheme,
      };
    }
    // 更新 planData中某一项的内容
    case 'UPDATE_MODE': {
      const planData = [...state.planData];
      planData[action.payload.planKey] = {
        ...planData[action.payload.planKey],
        ...action.payload.obj,
      };

      if (action.payload.obj && Object.keys(action.payload.obj)[0] === 'ladder_unit') {
        const plan_plans = [...planData[action.payload.planKey].plans].map((item) => ({
          ...item,
          paid_params: {
            ...item.paid_params,
            ladder_unit: action.payload.obj.ladder_unit,
          },
        }));
        planData[action.payload.planKey] = {
          ...planData[action.payload.planKey],
          plans: plan_plans,
        };
      }

      if (action.payload.obj && Object.keys(action.payload.obj)[0] === 'hide') {
        const modeNoMap = { ...state.modeNoMap };
        let current = action.payload.planKey + 1;
        while (current < planData.length) {
          const newNo = modeNoMap[current][0] - 1;
          modeNoMap[current] = [newNo, intToChinese(newNo)];
          current += 1;
        }
        return {
          ...state,
          planData,
          modeNoMap,
        };
      }

      return {
        ...state,
        planData,
      };
    }
    case 'UPDATE_MODE3_PAID_PARAM_LADDER_UNIT': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans];
      const condition = { ...plan_plans[action.payload.conditionIndex] };
      const conditions = {
        ...condition,
        ladder_unit: action.payload.value,
      }; // 改变plan下的plans的地址
      plan.plans[action.payload.conditionIndex] = conditions;
      planData[action.payload.planKey] = plan;

      return {
        ...state,
        planData,
      };
    }
    case 'DELETE_MODE': {
      const planData = [...state.planData];
      planData.splice(action.payload, 1);
      return {
        ...state,
        planData,
      };
    }
    // 改变plans下的某一项
    case 'UPDATE_CONDITION': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans]; // 改变plan下的plans的地址
      plan_plans[action.payload.conditionIndex] = {
        ...plan_plans[action.payload.conditionIndex],
        ...action.payload.obj,
      };
      plan.plans = plan_plans;
      planData[action.payload.planKey] = plan;
      return {
        ...state,
        planData,
      };
    }
    case 'UPDATE_PAID_PARAMS': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans]; // 改变plan下的plans的地址
      const condition = { ...plan_plans[action.payload.conditionIndex] }; // 改变plan下的plans的某一项的地址
      const paid_params = [...condition.paid_params]; // 改变plan下的plans的某一项的paid_params的地址
      paid_params[action.payload.paidParamIndex] = {
        ...paid_params[action.payload.paidParamIndex],
        ...action.payload.obj,
      };
      condition.paid_params = paid_params;
      plan_plans[action.payload.conditionIndex] = condition;
      plan.plans = plan_plans;
      planData[action.payload.planKey] = plan;

      return {
        ...state,
        planData,
      };
    }
    case 'UPDATE_PAID_PARAMS_OBJ': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans]; // 改变plan下的plans的地址
      const condition = { ...plan_plans[action.payload.conditionIndex] }; // 改变plan下的plans的某一项的地址
      const list = [...condition.paid_params];
      const item = { ...list[action.payload.listIndex] };
      const paid_params = {
        ...item.paid_params,
        ...action.payload.obj,
      }; // 改变plan下的plans的某一项的paid_params的地址
      condition.paid_params[action.payload.listIndex].paid_params = paid_params;
      plan_plans[action.payload.conditionIndex] = condition;
      plan.plans = plan_plans;
      planData[action.payload.planKey] = plan;

      return {
        ...state,
        planData,
      };
    }
    case 'ADD_PAID_PARAMS': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans]; // 改变plan下的plans的地址
      const condition = { ...plan_plans[action.payload.conditionIndex] }; // 改变plan下的plans的某一项的地址
      condition.paid_params = [
        ...condition.paid_params,
        {
          ...PAY_ARG_DEFINE,
          key: generateUniqKey('paid_param', condition.paid_params.length),
        },
      ];
      plan_plans[action.payload.conditionIndex] = condition;
      plan.plans = plan_plans;
      planData[action.payload.planKey] = plan;
      return {
        ...state,
        planData,
      };
    }
    case 'DELETE_PAID_PARAMS': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans]; // 改变plan下的plans的地址
      const condition = { ...plan_plans[action.payload.conditionIndex] }; // 改变plan下的plans的某一项的地址
      const paid_params = [...condition.paid_params];
      paid_params.splice(action.payload.paidParamIndex, 1);
      condition.paid_params = paid_params;
      plan_plans[action.payload.conditionIndex] = condition;
      plan.plans = plan_plans;
      planData[action.payload.planKey] = plan;
      return {
        ...state,
        planData,
      };
    }
    // mode === 4 增加一组计算模式
    case 'ADD_MODE': {
      let i = state.planData.length - 1;
      let last;
      while (!state.planData[i].hide && !last) {
        last = state.modeNoMap[state.planData.length - 1];
        i -= 1;
      }
      return {
        ...state,
        planData: [
          ...state.planData,
          {
            ...CALCMODE1_CONFIG,
            key: generateUniqKey('planData', 0),
            plans: [
              {
                ...PAY_PLAN_DEFINE,
                key: generateUniqKey('plans', 0),
                paid_params: [
                  {
                    ...PAY_ARG_DEFINE,
                    key: generateUniqKey('paid_param', 0),
                  },
                ],
              },
            ],
          },
        ],
        modeNoMap: {
          ...state.modeNoMap,
          [state.planData.length]: [last[0] + 1, intToChinese(last[0] + 1)],
        },
      };
    }
    // 增加一组阶梯条件
    case 'ADD_STAGE_CONDITION': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] };
      const plan_plans = [...plan.plans];
      const condition = { ...plan_plans[action.payload.conditionIndex] };
      const list = [...condition.paid_params];
      const last1 = list.pop();
      const last2 = list.pop();
      const newLists = [
        ...list,
        last2,
        {
          ...last2,
          fixed_value: undefined,
          sub_compute_mode: undefined,
          unit: undefined,
          unit_work_time: undefined,
          paid_params: {
            ...last2.paid_params,
            left_value: last2.paid_params.right_value || 0,
            left_operator: state.paramsData.operatorLadder.filter(
              (item) => item !== last2.paid_params.right_operator,
            )[0],
          },
          key: generateUniqKey('plans', plan_plans.length),
        },
        last1,
      ];
      plan.plans[action.payload.conditionIndex].paid_params = newLists;
      planData[action.payload.planKey] = plan;

      return {
        ...state,
        planData,
      };
    }
    // 删除阶梯条件
    case 'DELETE_STAGE_CONDITION': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans]; // 改变plan下的plans的地址
      const condition = { ...plan_plans[action.payload.conditionIndex] };
      const list = [...condition.paid_params];
      list.splice(action.payload.listIndex, 1);
      const last = list[action.payload.listIndex - 1];

      list[action.payload.listIndex] = {
        ...list[action.payload.listIndex],
        paid_params: {
          ...list[action.payload.listIndex].paid_params,
          left_value: last.paid_params.right_value,
          left_operator: state.paramsData.operatorLadder.filter(
            (item) => item !== last.paid_params.right_operator,
          )[0],
        },
      };
      plan.plans[action.payload.conditionIndex].paid_params = list;
      // plan.plans = plan_plans;
      planData[action.payload.planKey] = plan;

      return {
        ...state,
        planData,
      };
    }
    // 增加一组计薪条件
    case 'ADD_CONDITION': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans];
      plan.plans = [
        ...plan_plans,
        {
          ...PAY_PLAN_DEFINE,
          paid_params: [
            {
              ...PAY_PLAN_DEFINE.paid_params[0],
              key: generateUniqKey('paid_param', 0),
            },
          ],
          key: generateUniqKey('plans', plan_plans.length),
        },
      ];
      planData[action.payload.planKey] = plan;

      return {
        ...state,
        planData,
      };
    }
    // 删除一组计薪条件
    case 'DELETE_CONDITION': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans];
      plan_plans.splice(action.payload.conditionIndex, 1);
      plan.plans = plan_plans;
      planData[action.payload.planKey] = plan;

      return {
        ...state,
        planData,
      };
    }
    // 兼容阶梯的新增计薪参数
    case 'ADD_STAGE_PAID_PARAMS': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans]; // 改变plan下的plans的地址
      const condition = { ...plan_plans[action.payload.conditionIndex] }; // 改变plan下的plans的某一项的地址
      condition.paid_plan_param = [
        ...condition.paid_plan_param,
        {
          ...PAY_ARG_DEFINE,
          key: generateUniqKey('paid_plan_param', condition.paid_plan_param.length),
        },
      ];
      plan_plans[action.payload.conditionIndex] = condition;
      plan.plans = plan_plans;
      planData[action.payload.planKey] = plan;
      return {
        ...state,
        planData,
      };
    }
    // 兼容阶梯的删除计薪参数
    case 'DELETE_STAGE_PAID_PARAMS': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans]; // 改变plan下的plans的地址
      const condition = { ...plan_plans[action.payload.conditionIndex] }; // 改变plan下的plans的某一项的地址
      const paid_plan_param = [...condition.paid_plan_param];
      paid_plan_param.splice(action.payload.paidParamIndex, 1);
      condition.paid_plan_param = paid_plan_param;
      plan_plans[action.payload.conditionIndex] = condition;
      plan.plans = plan_plans;
      planData[action.payload.planKey] = plan;
      return {
        ...state,
        planData,
      };
    }
    // 兼容阶梯的增加一组计薪条件
    case 'ADD_STAGE_CONDITION_CONTENT': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans];
      plan.plans = [
        ...plan_plans,
        {
          paid_plan_param: [
            {
              ...PAY_ARG_DEFINE,
              key: generateUniqKey('paid_plan_param', 0),
            },
          ],
          paid_params: STAGE_PAY_PLAN_DEFINE.map((item, index) => ({
            ...item,
            key: generateUniqKey('paid_params', index),
          })),
          key: generateUniqKey('plans', 0),
        },
      ];
      planData[action.payload.planKey] = plan;

      return {
        ...state,
        planData,
      };
    }
    // 兼容阶梯的计薪参数
    case 'UPDATE_STAGE_PAID_PARAMS': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans]; // 改变plan下的plans的地址
      const condition = { ...plan_plans[action.payload.conditionIndex] }; // 改变plan下的plans的某一项的地址
      const paid_plan_param = [...condition.paid_plan_param]; // 改变plan下的plans的某一项的paid_params的地址
      paid_plan_param[action.payload.paidParamIndex] = {
        ...paid_plan_param[action.payload.paidParamIndex],
        ...action.payload.obj,
      };
      condition.paid_plan_param = paid_plan_param;
      plan_plans[action.payload.conditionIndex] = condition;
      plan.plans = plan_plans;
      planData[action.payload.planKey] = plan;

      return {
        ...state,
        planData,
      };
    }
    // 兼容阶梯的改变(删除)plans下的某一项
    case 'UPDATE_STAGE_CONDITION': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans]; // 改变plan下的plans的地址
      plan_plans[action.payload.conditionIndex] = {
        ...plan_plans[action.payload.conditionIndex],
        ...action.payload.obj,
      };
      plan.plans = plan_plans;
      planData[action.payload.planKey] = plan;
      return {
        ...state,
        planData,
      };
    }
    // 兼容阶梯的改变 改变阶梯的计价模式
    case 'UPDATE_STAGE_LIST_CONDITION': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans]; // 改变plan下的plans的地址
      const condition = { ...plan_plans[action.payload.conditionIndex] };
      const paid_param = [...condition.paid_params];
      paid_param[action.payload.listIndex] = {
        ...paid_param[action.payload.listIndex],
        ...action.payload.obj,
      };
      condition.paid_params = paid_param;
      plan_plans[action.payload.conditionIndex] = condition;
      plan.plans = plan_plans;
      planData[action.payload.planKey] = plan;
      return {
        ...state,
        planData,
      };
    }
    // 兼容阶梯的 更新 planData中某一项的内容
    case 'UPDATE_STAGE_MODE': {
      const planData = [...state.planData];
      const plan = { ...planData[action.payload.planKey] }; // 改变plan地址
      const plan_plans = [...plan.plans];
      plan_plans[action.payload.conditionIndex] = {
        ...plan_plans[action.payload.conditionIndex],
        ...action.payload.obj,
      };
      planData[action.payload.planKey] = {
        ...planData[action.payload.planKey],
        plans: plan_plans,
      };
      return {
        ...state,
        planData,
      };
    }
    default:
      return state;
  }
};
